// extracted by mini-css-extract-plugin
export default {"component":"checklistDialog__component___X7ijW"};